import {
  DELETE_ACTIVITY_ADD_ONS,
  DELETE_ACTIVITY_MANDATORY_FEES,
  DELETE_RELATED_ACCOMMODATIONS,
  DELETE_RELATED_ACTIVITIES,
  DELETE_INTEGRATIONS,
  CLEAR_DELETED_FIELDS
} from 'constants/activityAndAccommodationActionTypes';

const deleteAddOns = id => {
  return { type: DELETE_ACTIVITY_ADD_ONS, id };
};

const deletedMandatoryFees = id => {
  return { type: DELETE_ACTIVITY_MANDATORY_FEES, id };
};

const deleteRelatedAccommodations = id => {
  return { type: DELETE_RELATED_ACCOMMODATIONS, id };
};

const deleteRelatedActivities = id => {
  return { type: DELETE_RELATED_ACTIVITIES, id };
};

const deleteIntegrations = id => {
  return { type: DELETE_INTEGRATIONS, id };
};

const clearDeletedFields = () => {
  return { type: CLEAR_DELETED_FIELDS };
};

export {
  deleteAddOns,
  deletedMandatoryFees,
  deleteRelatedAccommodations,
  deleteRelatedActivities,
  deleteIntegrations,
  clearDeletedFields
};
